import React, { Fragment, useState } from "react";
import SaleList from "src/Components/Custom/SaleList/SaleList";
import SalePostDetail from "src/Components/Custom/SalePostDetail/SalePostDetail";
import SalePostModal from "src/Components/Custom/SalePostModal/SalePostModal";
import EndPoints from "src/Constants/EndPoints";
import { useTranslation } from "react-i18next";

function Sales({ modalVisibility, setModalVisibility }: any) {
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState<string>('');
  const [postData, setPostData] = useState<any>([]);
  const [detailView, setDetailView] = useState<boolean>(false);
  return (
    <div id="content" className={`${i18n.dir() === 'rtl'?'rtl-content-padding':'ltr-content-padding'}`}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-9">
            <div className="col_selector">
              <div className="messages pt-4 post_feed">
                {detailView ? (
                  <SalePostDetail
                    postData={postData}
                    setPostData={setPostData}
                    setDetailView={setDetailView}
                    setModalVisibility={setModalVisibility}
                  />
                ) : (
                    <SaleList
                      endPoint={EndPoints.getSales}
                      placeholderMessage={"Sales Post not found"}
                      setPostData={setPostData}
                      setModalVisibility={setModalVisibility}
                      setDetailView={setDetailView}
                      search={search}
                      setSearch={setSearch}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalVisibility ? (
        <SalePostModal
          postData={postData}
          setPostData={setPostData}
          showModal={modalVisibility}
          setModalVisibility={setModalVisibility}
        />
      ) : (
          <Fragment />
        )}
    </div>
  );
}

export default Sales;
